<template>
    
    <div class="text-center">
      <!-- <v-container> -->
        <v-dialog v-model="showDialog" width="700" @click:outside="closeDialog" >
          <v-card class="elevation-0" :disabled="$store.getters.dialogLoader" v-if="item">

              <v-card-title class="primary lighten-2">                
                  Assinatura
                  <v-spacer></v-spacer>
                  <v-btn icon @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
              </v-card-title>
              <v-card-text class="pt-10">
              
                <v-row v-if="item != null">
                
                  <v-col cols="12" md="6"  sm="12" class="pt-0 pb-0">
                    <v-text-field
                      v-model="item.ownerName"
                      label="Assinante"
                      prepend-icon="mdi-account"
                      readonly
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6"  sm="12" class="pt-0 pb-0">
                    <v-text-field
                      v-model="item.plano.name"
                      label="Plano"
                      prepend-icon="mdi-ticket"
                      readonly
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                   <v-col cols="12" md="6"  sm="12" class="pt-0 pb-0">
                    <v-text-field
                      v-model="item.dtCreated"
                      label="Data de Processamento"
                      prepend-icon="mdi-calendar-check-outline"
                      readonly
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6"  sm="12" class="pt-0 pb-0">
                    <v-text-field
                      v-model="item.vencimento"
                      label="Vencimento"
                      prepend-icon="mdi-calendar-clock"
                      readonly
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                </v-row>

                <v-row v-if="item.cobrancaApp">

                  <v-col cols="12" class="title pb-8">
                    <v-divider class="pb-2"></v-divider>
                    Dados de Pagamento:
                  </v-col>

                  <v-col cols="12" md="6"  sm="12" class="pt-0 pb-0">
                    <v-text-field
                      v-model="item.paymentMethod"
                      label="Forma de Pagamento"
                      prepend-icon="mdi-cash-register"
                      readonly
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6"  sm="12" class="pt-0 pb-0">
                    <v-text-field
                      v-model="item.formattedPrice"
                      label="Valor Pago"
                      prepend-icon="mdi-cash-usd-outline"
                      readonly
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6"  sm="12" class="pt-0 pb-0">
                    <v-text-field v-if="item.gatewayTransactionId"
                      v-model="item.gatewayTransactionId"
                      label="ID na Pagar.me"
                      prepend-icon="mdi-file-link-outline"
                      readonly
                      outlined
                      dense
                    ></v-text-field>
                    <v-text-field v-if="!item.gatewayTransactionId"
                      value="Não existe"
                      label="ID na Pagar.me"
                      prepend-icon="mdi-file-link-outline"
                      readonly
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6"  sm="12" class="pt-0 pb-0">
                    <v-text-field v-if="item.paymentStatus"
                      v-model="item.paymentStatus"
                      label="Status na Pagar.me"
                      prepend-icon="mdi-file-link-outline"
                      readonly
                      outlined
                      dense
                    ></v-text-field>
                    <v-text-field v-if="!item.paymentStatus"
                      value="Não existe"
                      label="Status na Pagar.me"
                      prepend-icon="mdi-file-link-outline"
                      readonly
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="title pb-8" v-if="item.paymentErrorMessage && item.paymentErrorMessage.length > 0">
                    Erro ao processar o pedido na Pagar.me:<br/>
                    <span class="" style="color: red;">
                      {{item.paymentErrorMessage.substring(item.paymentErrorMessage.lastIndexOf(':') + 1)}}
                    </span>
                  </v-col>

                  <v-col cols="12" class="pt-8 pb-0 text-center body-1" v-if="errorMessage">
                    <span class="custom-error">{{errorMessage}}</span>
                  </v-col>

                </v-row>

              </v-card-text>
              <!-- <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" v-if="!item.id" :disabled="$v.item.$invalid" @click="saveItem">
                  Salvar
                  <v-icon right>mdi-cloud-upload</v-icon>
                </v-btn>
                <v-btn color="primary" v-if="item.id">
                  Atualizar
                  <v-icon right>mdi-cloud-upload</v-icon>
                </v-btn>
              </v-card-actions> -->

          </v-card>
        </v-dialog>
        
      <!-- </v-container> -->

      
    </div>

</template>

<script>

import HOST from '../ws';
import { required, minLength } from "vuelidate/lib/validators";
import SnackBar from '../snackbar'



export default {

  props : {
    item : Object,
    showDialog : Boolean, 
  },

  computed : {

  },

  data: () => ({

    myHost : HOST.HOST,
    errorMessage : null,

    tipoList : null,

    externalTransaction : null,

  }),

  beforeMount() {

    //item.gatewayTransactionId
    // const config = {
    //   headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
    // };
    // this.axios
    // .post(this.myHost + "/assinatura/loadpagarmetransaction/" + this.item.gatewayTransactionId, {}, config)
    // .then(response => {
    //   this.externalTransaction = response.data;
    //   console.log(JSON.stringify(this.externalTransaction));
    // });

  },

  

  methods : {

    closeDialog(){
      this.$emit('close-dialog', false);
    },

    
    saveItem() {

      this.$store.commit("setDialogLoader", true);
      
      this.axios({
        method: "post",
        url: this.myHost + "/plano/save",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.currentToken}`
        },
        data: JSON.stringify(this.item)
      }).then(response => {
        console.log("salvando item: " + response.status);
        this.$store.commit("setDialogLoader", false);
        this.closeDialog();
        SnackBar.snackText = "Item salvo com sucesso";
        SnackBar.showSnack = true;
      });
    }
    

  },

  validations: {

    item: {
      name: {
        required,
        minLength: minLength(2)
      },
      price: {
        required,
      },
      shortDescription: {
        required,
        minLength: minLength(10),
      },
      planType: {
        required,
      },
      
    },
  }

};
</script>